// src/components/Swimming/SwimmingMetricsProcessor.js
import { useEffect } from 'react';
import axios from 'axios';
import { calculateSwimmingPace } from '../../utils/paceSwimmingUtils';
import { calculateTSSWithTerrainSwimming as calculateTSS } from '../../utils/tssSwimmingUtils';
import { formatTimeToHHMMSS } from '../../utils/formatTimeToMMSS';
import API_BASE_URL from '../../config/api';
import { calculateSwolf } from '../../utils/swolfUtils';
import { calculateSwimmingVO2max } from '../../utils/vo2SwimmingUtils'; // ✅ Importación agregada

const SwimmingMetricsProcessor = ({ fileId, onSummaryData }) => {
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/fit/parsed-data/${fileId}`);
        const data = res.data;
        const session = data?.sessions?.[0] || data?.session || {};
        const records = data?.records || [];
        const laps = data?.laps || [];

        const activeLaps = Array.isArray(laps)
          ? laps.filter(lap => lap.total_distance > 0 && lap.total_timer_time > 0)
          : [];

        let movementTime = 0;
        let movementDistance = 0;

        if (activeLaps.length > 0) {
          movementTime = activeLaps.reduce((sum, lap) => sum + (lap.total_timer_time || 0), 0);
          movementDistance = activeLaps.reduce((sum, lap) => sum + (lap.total_distance || 0), 0);
        } else {
          movementTime = session.total_timer_time || 0;
          movementDistance = session.total_distance || 0;
        }

        const swolf = calculateSwolf(laps); // ✅ Definición agregada

        const completed = {
		  fileId,
		  duracion: session.total_timer_time ? formatTimeToHHMMSS(session.total_timer_time) : '00:00:00', // ✅ total
		  distancia: movementDistance || 0,
		  calorias: session.total_calories || 0,
		  ritmo_medio: (movementDistance > 0 && movementTime > 0)
			? calculateSwimmingPace(movementDistance, movementTime).replace(' /100m', '') // ✅ sin texto
			: '',
		  tte: session.total_training_effect ?? session.training_effect ?? '',
		  tea: session.total_anaerobic_effect ?? session.training_effect_anaerobic ?? '',
		  tss: (() => {
			const tssData = calculateTSS(data);
			return isFinite(tssData?.tss) ? Number(tssData.tss) : '';
		  })(),
		  swolf: isFinite(swolf) ? parseFloat(swolf.toFixed(1)) : ''
		};


        const metrics = {
          ritmo_cardiaco: {
            min: session.min_heart_rate || null,
            avg: session.avg_heart_rate || null,
            max: session.max_heart_rate || null
          }
        };

        if (typeof onSummaryData === 'function') {
          onSummaryData({ session, completed, laps, records, metrics });
        }
      } catch (error) {
        console.error('❌ Error al obtener datos de natación:', error);
      }
    };

    if (fileId) {
      fetchData();
    }
  }, [fileId, onSummaryData]);

  return null;
};

export default SwimmingMetricsProcessor;
